import { Controller } from 'react-hook-form';

import { ERROR_REQUIRED_FIELD } from '@/constants';
import { CustomButtonGroup, Input } from '@/components/common';

import {
  AccessControlMode,
  IIpadConfigDetails,
  IPAD_CONFIG_FORM_FIELDS,
  IPAD_CONFIG_PROJECT_NAME_MAX_LENGTH,
  IProjectRoomSection,
  getAccessControlModeLabel,
} from '@/features/ipad-configs';
import AllowedMembersSection from './AllowedMembersSection';

const ProjectRoomSection = ({
  register,
  control,
  watch,
  errors,
  defaultValues,
}: IProjectRoomSection & { defaultValues: IIpadConfigDetails }) => {
  const accessControlModeValue = watch(IPAD_CONFIG_FORM_FIELDS.accessControlMode);

  return (
    <div className="flex flex-col gap-6">
      <div className="w-full h-px bg-neutral-n3"></div>
      <h5 className="font-bold text-h5 text-brand-primary-darkest">Project Details</h5>
      <Input
        label="Project Name"
        placeholder="Project Name"
        required
        maxLength={IPAD_CONFIG_PROJECT_NAME_MAX_LENGTH}
        error={errors[IPAD_CONFIG_FORM_FIELDS.projectName]?.message}
        {...register(IPAD_CONFIG_FORM_FIELDS.projectName)}
      />
      <Controller
        name={IPAD_CONFIG_FORM_FIELDS.accessControlMode}
        control={control}
        rules={{ required: ERROR_REQUIRED_FIELD }}
        render={({ field }) => (
          <CustomButtonGroup
            buttonNames={[
              {
                name: getAccessControlModeLabel(AccessControlMode.OpenAccess),
                value: AccessControlMode.OpenAccess,
              },
              {
                name: getAccessControlModeLabel(AccessControlMode.RestrictedAccess),
                value: AccessControlMode.RestrictedAccess,
              },
            ]}
            selectedIndex={field.value as AccessControlMode}
            onSelect={(index) => field.onChange(index)}
            required
            label="Access Control Mode"
            buttonClass="w-[170px]"
            error={errors[IPAD_CONFIG_FORM_FIELDS.accessControlMode]?.message}
          />
        )}
      />
      <div className="w-full h-px bg-neutral-n3"></div>
      {accessControlModeValue === AccessControlMode.RestrictedAccess && (
        <AllowedMembersSection defaultValues={defaultValues} control={control} errors={errors} />
      )}
    </div>
  );
};

export default ProjectRoomSection;
